import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { formatDate, formatMoney, getInlineLoader, setCookie } from "../Helpers";
import {
	STR_AMOUNT,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLOSING_BALANCE,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_CREATE_NEW,
	STR_DATE,
	STR_DESCRIPTON,
	STR_FLOAT,
	STR_LOGOUT,
	STR_MY_COACH,
	STR_MY_CREATED_AGENT_REQUESTS,
	STR_MY_STUDENTS,
	STR_NO_RECORD,
	STR_OPENING_BALANCE,
	STR_PAYABLE,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECEIVABLE,
	STR_REPORT_FOR,
	STR_REPORT_TYPE,
	STR_SET_CURRENCY,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_TILL_NUMBER,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_WHATSAPP_SETUP,
	STR_YOUR_PROFILE,
	STR_YOUR_REPORTS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdDetails, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupportAgent, MdTranslate, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import { RiProfileLine } from "react-icons/ri";
import EditAgentProfile from "./EditAgentProfile";
import OneAgentRequest from '../ones/OneAgentRequest';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getMyCreatedAgentRequests(),
			appContext.getCurrentUserData(),
		])
		setReady(true);
	}

	
	useEffect(() => {
		init();
	}, [])



	if (ready) {
		if(appContext.isAgentProfileComplete) {
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						overflow: "scroll",
						paddingTop: "20px",
						paddingBottom: "calc(var(--topBarHeight) + 40px)",
					}}
					className="mNoScrollBar"
				>
					<div className="container">

						<div className="row">

							<div className="col-md-12">
								<h6
									className="mSectionTitle"
								>
									{STR_MY_CREATED_AGENT_REQUESTS[appContext.language]}
								</h6>
							</div>

							<div className="col-md-12">
								{
									(appContext.myCreatedAgentRequests && appContext.myCreatedAgentRequests.length > 0) ?
									appContext.myCreatedAgentRequests.map((item, i) => {
										return (
											<OneAgentRequest key={i} data={item}/>
										)
									})
									:
									<h6>{STR_NO_RECORD[appContext.language]}</h6>
								}
							</div>

						</div>

					</div>


				</div>
			)
			
		} else {
			return <EditAgentProfile/>
		}
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}